import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import { MatDateRangePicker} from '@angular/material/datepicker';
import {CustomHeaderComponent} from '../custom-header/custom-header.component';
import {DateRangePickerService} from './date-range-picker.service';
import { RangePresetKey } from '../custom-header/custom-range-panel/custom-range-panel.component';
import { TextUtils } from '../../../../../shared/utils/text-utils';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { TranslatedDateAdapter } from '../../../../../components/common/range-calendar/translated-date-adapter';
import { Platform } from '@angular/cdk/platform';

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'monthYearLabel',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'date-range-picker',
    templateUrl: './date-range-picker.component.html',
    providers: [
        DateRangePickerService,
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        {
            provide: DateAdapter,
            useClass: TranslatedDateAdapter,
            deps: [MAT_DATE_LOCALE, Platform]
        },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
    ],
    standalone: false
})
export class DateRangePickerComponent implements OnInit, OnChanges {
  @Input() customPresets: RangePresetKey[] = [];
  @Input() selectedDates: {};
  public choosenDates: string;
  public comparedDates: string;
  @ViewChild(MatDateRangePicker) picker: MatDateRangePicker<Date>;
  CustomHeaderComponent = CustomHeaderComponent;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  @Output() dateRange = new EventEmitter<any>();



  constructor(public pickerService: DateRangePickerService) {
  }

  ngOnInit() {
    this.pickerService.customPresets = this.customPresets;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedDates'] && changes['selectedDates'].currentValue) {
      const newDates = changes['selectedDates'].currentValue[0];
      this.choosenDates = this._changeDateFormat(newDates['startDate'], newDates['endDate']);
      this.comparedDates = this._changeDateFormat(newDates['prevStartDate'], newDates['prevEndDate']);
      this.range.controls.start.setValue(newDates['startDate']);
      this.range.controls.end.setValue(newDates['endDate']);
    }
  }

  private _changeDateFormat(timestampStart, timeStampEnd): string {
    const startDate = new Date(timestampStart);
    const endDate = new Date(timeStampEnd);

    // Array of month names to convert month number to month name (using translations)
    const monthNames = [
      TextUtils.getText('text_jan'),
      TextUtils.getText('text_feb'),
      TextUtils.getText('text_mar'),
      TextUtils.getText('text_apr'),
      TextUtils.getText('text_may'),
      TextUtils.getText('text_jun'),
      TextUtils.getText('text_jul'),
      TextUtils.getText('text_aug'),
      TextUtils.getText('text_sep'),
      TextUtils.getText('text_oct'),
      TextUtils.getText('text_nov'),
      TextUtils.getText('text_dec')
    ];

    // Format the date
    return `${monthNames[startDate.getMonth()]} ${startDate.getDate()} - ${monthNames[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear()}`;
  }

  applySelectedDate(picker: MatDateRangePicker<Date>) {
    this.range.setValue({
      start: (picker.datepickerInput as any).value.start,
      end: (picker.datepickerInput as any).value.end,
    });
    picker.close();
    this.dateRange.emit(this.range?.value);
    console.log(this.range?.value);
  }
}
